import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import {Subscription} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Subscription,
        // Returns a promise so the drawer can AWAIT it before closing (§7).
        handleSubmit: (values: Subscription) => void | Promise<unknown>
    }) => {

    const title = record?.id ? 'Edit Subscription' : 'Add Subscription';

    const handleFormSubmit = async (values: Subscription) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            size="xl"
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
